export enum BranchType {
    Automotor = 'Automotor',
    Hogar = 'Hogar',
    AccidentesPersonales = 'Accidentes Personales',
    IntegralComercio = 'Integral de Comercio'
}
